import { useState } from "react";
import About from "../components/about/about";
import Blogs from "../components/blogs/blogs";
import Resume from "../components/resume/resume";
import Contact from "../components/contact/contact";
import Projects from "../components/projects/project";

function useActiveTab(initialTab = "About") {
  const [activeTab, setActiveTab] = useState(initialTab);

  const renderContent = () => {
    switch (activeTab) {
      case "About":
        return <About />;
      case "Resume":
        return <Resume />;
      case "Projects":
        return <Projects />;
      case "Blogs":
        return <Blogs />;
      case "Contact":
        return <Contact />;
      default:
        return <About />;
    }
  };

  return { activeTab, setActiveTab, renderContent };
}

export default useActiveTab;
